import React from 'react';
import { Check, Copy, ExternalLink, QrCode, Smartphone, ChefHat } from 'lucide-react';
import { Badge } from 'reactstrap';

const THEME_COLOR = '#c59253';

const ExperienceComplete = ({ state }) => {
    const handleCopyToken = (token) => {
        navigator.clipboard.writeText(token);
    };

    return (
        <div className="h-100 overflow-auto py-5 bg-light">
            <div className="container" style={{ maxWidth: '900px' }}>
                <div className="text-center mb-5">
                    <div className="d-flex align-items-center justify-content-center rounded-circle mx-auto mb-4" style={{ width: '80px', height: '80px', backgroundColor: THEME_COLOR }}>
                        <Check size={40} className="text-white" />
                    </div>
                    <h1 className="display-6 fw-bold">Stations Configured!</h1>
                    <p className="text-muted lead">Your kitchen routing and preparation areas are ready to go.</p>
                </div>

                <div className="row g-4">
                    {/* Left: Summary & Tokens */}
                    <div className="col-lg-7">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-header bg-white p-4 border-bottom">
                                <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
                                    <ChefHat size={20} style={{ color: THEME_COLOR }} />
                                    Active Station Tokens
                                </h5>
                            </div>
                            <div className="card-body p-4">
                                <div className="d-flex flex-column gap-3">
                                    {state.stations.map((station) => (
                                        <div key={station.id} className="p-3 bg-light border rounded-4">
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <h6 className="mb-0 fw-bold">{station.name}</h6>
                                                <Badge color="soft-primary">ACTIVE</Badge>
                                            </div>
                                            <div className="input-group input-group-sm mt-3">
                                                <code className="form-control bg-white border-2 text-primary font-monospace p-2">
                                                    {station.token}
                                                </code>
                                                <button
                                                    onClick={() => handleCopyToken(station.token)}
                                                    className="btn btn-outline-secondary border-2"
                                                >
                                                    <Copy size={14} />
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                    {state.stations.length === 0 && <p className="text-center text-muted py-5">No stations created.</p>}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right: QR & Instructions */}
                    <div className="col-lg-5">
                        <div className="card border-0 shadow-sm rounded-4 bg-primary text-white mb-4 overflow-hidden">
                            <div className="card-body p-4 text-center position-relative">
                                {/* Decorative circle */}
                                <div className="position-absolute top-0 end-0 p-5 opacity-10" style={{ transform: 'translate(30%, -30%)' }}>
                                    <QrCode size={120} />
                                </div>

                                <h5 className="fw-bold mb-4">Test Your Flow</h5>
                                <div className="bg-white p-3 rounded-4 d-inline-block shadow-lg mb-4">
                                    <svg viewBox="0 0 100 100" className="p-2" style={{ width: '160px', height: '160px' }}>
                                        <rect x="0" y="0" width="100" height="100" fill="white" />
                                        <rect x="10" y="10" width="30" height="30" fill="black" />
                                        <rect x="60" y="10" width="30" height="30" fill="black" />
                                        <rect x="10" y="60" width="30" height="30" fill="black" />
                                        <rect x="15" y="15" width="20" height="20" fill="white" />
                                        <rect x="65" y="15" width="20" height="20" fill="white" />
                                        <rect x="15" y="65" width="20" height="20" fill="white" />
                                        <rect x="40" y="40" width="20" height="20" fill="black" />
                                        <rect x="45" y="45" width="10" height="10" fill="white" />
                                    </svg>
                                </div>
                                <p className="small opacity-90 px-3">Scan this QR code to view your digital menu and place a test order.</p>
                                <button className="btn btn-light rounded-pill w-100 fw-bold d-flex align-items-center justify-content-center gap-2">
                                    <ExternalLink size={16} /> Open Store
                                </button>
                            </div>
                        </div>

                        <div className="card border-0 shadow-sm rounded-4">
                            <div className="card-body p-4">
                                <h6 className="fw-bold mb-3 d-flex align-items-center gap-2">
                                    <Smartphone size={18} style={{ color: THEME_COLOR }} />
                                    Next Steps
                                </h6>
                                <ol className="small text-muted p-0 ps-3 d-flex flex-column gap-2 mb-0">
                                    <li><strong>Scan Code:</strong> Open your store and place a test order.</li>
                                    <li><strong>Log in Station:</strong> Open the Kitchen App on a tablet or PC.</li>
                                    <li><strong>Use Token:</strong> Enter the station token (from the left) to authenticate.</li>
                                    <li><strong>Manage:</strong> Watch your order arrive at the correct station!</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .bg-primary { background-color: #c59253 !important; }
                .text-primary { color: #c59253 !important; }
                .bg-soft-primary { background-color: rgba(197, 146, 83, 0.1) !important; }
            `}</style>
        </div>
    );
};

export default ExperienceComplete;
